<template>
  <div class="campaign-compare-section">
    <h3 class="text-center"> comparing {{campaignIds.length}} campaigns</h3>
    <div>
      <div class="text-center">
        tracking duration post customer reception of campaign
      </div>
      <div class="duration-container flex flex-row content-center justify-center">
        <template v-for="duration in trackingDurationList">
          <input
            v-model="trackingDuration"
            class="tracking-duration-radio"
            type="radio"
            :value="duration"
            :name="'duration-' + duration"
            :id="'duration-' + duration"/>
          <label
            class="tracking-duration-container"
            :key="`radio-${duration}`"
            :for="'duration-' + duration">
            {{ duration }}
          </label>
        </template>
      </div>
    </div>
    <div class="export-modal-btn text-center">
      <button class="button larger " @click="showExportModal = !showExportModal">export campaign data</button>
    </div>
    <div class="grid flex compare-container mt-6 w-full"
         :style="`grid-template-columns: repeat(${campaigns.length}, minmax(375px, 1fr))`">
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2 pt-2">
          <div class="campaign-details-section">
            <div class="campaign-title-id mb-2"> campaign #{{campaign.id}}</div>
            <table class="unstriped compare-campaign-details-table">
              <tbody>
                <tr>
                  <td>created at</td>
                  <td class="text-right">{{formattedDate(campaign.details.created_at)}}</td>
                </tr>
                <tr>
                  <td>scheduled for</td>
                  <td class="text-right">{{scheduledFor(campaign.details.send_at)}}</td>
                </tr>
                <tr>
                  <td>sent at</td>
                  <td class="text-right">{{sendAtStatus(campaign)}}</td>
                </tr>
                <tr>
                  <td>messages sent</td>
                  <td class="text-right">{{campaign.sms_sent + campaign.push_sent + campaign.email_sent}}</td>
                </tr>
                <tr>
                  <td>sms sent</td>
                  <td class="text-right">{{campaign.sms_sent}}</td>
                </tr>
                <tr>
                  <td>app sent</td>
                  <td class="text-right">{{campaign.push_sent}}</td>
                </tr>
                <tr>
                  <td>emails sent</td>
                  <td class="text-right">{{campaign.details.email_sent}}</td>
                </tr>
                <tr>
                  <td>extension</td>
                  <td class="text-right">
                    <template v-if="campaign._type === 1">
                      digital voucher
                    </template>
                    <template v-else-if="campaign._type === 5">
                      bonus points
                    </template>
                    <template v-else-if="campaign._type === 6">
                      instant points
                    </template>
                    <template v-else-if="campaign._type === 3">
                      target wallet
                    </template>
                    <template v-else-if="campaign._type === 4">
                      any link
                    </template>
                    <template v-else>
                      --
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <selected-groups
            v-if="campaign.details.has_groups"
            :campaignId="campaign.id"
            :selectedGroupsUrl="`/api/v3/campaigns/${campaign.id}/selected_groups?legacy=true`">
          </selected-groups>
          <template v-else>
            <div class="selected-groups-section">
              <div class="data-title">sent to these groups</div>
              <table class="selected-groups-table">
                <tbody>
                  <tr  class="selected-groups-row">
                    <td> all members </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <table class="track-table">
            <thead>
              <tr>
                <th class="text-center">visits</th>
                <th class="text-center">spend</th>
                <th class="text-center">clicks</th>
                <th class="text-center">actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center visits-calculated">
                  {{`${campaign.visits_calculations.count}(${campaign.visits_calculations.count_percentage.toFixed(1)}%)`}}
                </td>
                <td class="text-center visitor-spend">
                  {{campaign.visits_calculations.spend}}
                </td>
                <td class="text-center clicks-calculated">
                  {{`${campaign.clicks.count}(${campaign.clicks.percentage.toFixed(1)}%)`}}
                </td>
                <td class="text-center redemptions-calculated">
                  {{`${campaign.redemptions_rate_calculation.count}(${campaign.redemptions_rate_calculation.percentage.toFixed(1)}%)`}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <most-occurring-graph
            class="mt-4"
            :campaignId="campaign.id"
            :trackingDuration="trackingDuration"
            :key="`most-occurring-graph-${campaign.id}-${trackingDuration}`">
          </most-occurring-graph>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <recipients-graph
            class="mt-4"
            :campaignId="campaign.id"
            :trackingDuration="trackingDuration"
            :key="`recipients-graph-${campaign.id}-${trackingDuration}`">
          </recipients-graph>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <trend-line-graph
            class="mt-4"
            :campaignId="campaign.id"
            :trackingDuration="trackingDuration"
            :key="`trend-line-graph-${campaign.id}-${trackingDuration}`">
          </trend-line-graph>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <opt-out-graph
            class="mt-4"
            :campaignId="campaign.id"
            :trackingDuration="trackingDuration"
            :key="`opt-out-graph-graph-${campaign.id}-${trackingDuration}`">
          </opt-out-graph>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2">
          <collapsible-section
            title="campaign details"
            class="mt-4"
            :expanded.sync="campaign.detailsExpanded"
          >
            <campaign-details
              style="margin-top: 23px;"
              :campaignItem="campaign.details"
              :headerHide="true"
              :reviewStatus="campaign.details.review_status"
              :creditsUsed="creditsUsed(campaign)">
            </campaign-details>
            <template v-if="Number(campaign.details.email_sent) > 0">
              <div class="email-results title">email results</div>
              <table class="track-table">
                <thead>
                <tr>
                  <th class="text-center">bounced</th>
                  <th class="text-center">delivered</th>
                  <th class="text-center">opened</th>
                  <th class="text-center">unsub.</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="text-center">
                    {{campaign.email_stats.bounced}}
                  </td>
                  <td class="text-center">
                    {{campaign.email_stats.delivered}}
                  </td>
                  <td class="text-center">
                    {{campaign.email_stats.opened}}
                  </td>
                  <td class="text-center">
                    {{campaign.email_stats.unsubscribed}}
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
          </collapsible-section>
        </div>
      </template>
      <template v-for="campaign in campaigns">
        <div class="compare-item pr-2 pl-2 pb-2">
          <collapsible-section
            class="mt-4"
            title="campaign content"
            :expanded.sync="campaign.contentExpanded"
          >
            <content-section
              class="mt-6"
              :campaignItem="campaign.details"
              :headerHide="true"
            >
            </content-section>
          </collapsible-section>
        </div>
      </template>
    </div>
    <modal
      v-if="showExportModal"
      class="export-modal"
      :showClose="true"
      @close="closeExportModal"
      wrapperClasses="clicks-modal">
      <h6 slot="header" class="modal-header-title">export campaign data</h6>
      <div slot="body" class="body text-center">
        <p>
          are you sure you would like to export data from these campaigns?
        </p>
      </div>
      <div slot="action" class="action-container">
        <div class="btn-action export"
             v-if="!reportLink && campaignIds.length > 0"
             :class="{disable: disableExportBtnText}"
             @click="exportCampaign">{{ exportBtnText }}
        </div>
        <a v-if="reportLink"
           class="btn-action download"
           :href="reportLink">download</a>
        <div class="cancel-btn"
             @click="closeExportModal">cancel
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AxiosMixin from '../../mixins/AxiosMixin'
import Modal from '../../components/shared/Modal'
import LoadErrorMixin from '../../mixins/LoadErrorMixin'
import { mapGetters, mapState } from 'vuex'
import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
import {campaignAPI} from '../../services/api/campaignAPI'
import MerchantTimeZoneMixin from "../../mixins/MerchantTimeZoneMixin";
import {CollapsibleSection} from '@springbig/sb-components'
import CampaignDetails from "../../components/Campaigns/CampaignDetails";
import ContentSection from "../../components/CommunicationItems/ContentSection";
import SelectedGroups from "../../components/GroupWidget/SelectedGroups";
import {trackingDurationList} from "../../config/tracking";
import {reportsAPI} from "../../services/api/reportsAPI";
import MostOccurringGraph from "../../components/CommunicationItems/MostOccurringGraph.vue";
import OptOutGraph from "../../components/CommunicationItems/OptOutGraph.vue";
import RecipientsGraph from "../../components/CommunicationItems/RecipientsGraph.vue";
import TrendLineGraph from "../../components/CommunicationItems/TrendLineGraph.vue";

export default {
  name: 'CampaignCompare',

  components: {
    Modal,
    CollapsibleSection,
    CampaignDetails,
    ContentSection,
    SelectedGroups,
    MostOccurringGraph,
    OptOutGraph,
    RecipientsGraph,
    TrendLineGraph,
  },

  mixins: [AxiosMixin, LoadErrorMixin, UserAbilitiesMixin, MerchantTimeZoneMixin],

  data() {
    return {
      campaignIds: [],
      campaigns: [],
      trackingDuration: '2d',
      showExportModal: false,
      exportBtnText: 'export',
      disableExportBtnText: false,
      reportLink: '',
      detailsExpanded: false,
      trackingDurationList,
    }
  },
  methods: {
    resetExportModal() {
      this.disableExportBtnText = false
      this.reportLink = null
      this.exportBtnText = 'export'
    },
    closeExportModal() {
      this.showExportModal = false
      this.resetExportModal()
    },
    checkResponseStatus(id) {
      this.disableExportBtnText = true
      this.exportBtnText = 'waiting...'
      let interval = setInterval(() => {
        reportsAPI.fetchReport(id)
          .then(({ report }) => {
            if (report.download_url) {
              this.reportLink = report.download_url
              clearInterval(interval)
            }
            // add countdown to btn
            if (report.estimated_run_time_remaining) {
              this.exportBtnText = report.estimated_run_time_remaining
            } else {
              clearInterval(interval)
              this.exportBtnText = 'export again'
            }
            this.disableExportBtnText = false
          }).catch(error => {
          this.showExportModal = false
          clearInterval(interval)
          this.setLoadError(error)
          this.disableExportBtnText = false
        })
      }, 1000)
    },
    async exportCampaign() {
      this.loadingReport = true;
      const report = await reportsAPI.initializeReportJob({
        report: {
          type: 'Reports::CampaignExportReport',
          input_data: {
            event_value: this.campaignIds,
            duration: this.trackingDuration
          }
        }
      });
      this.checkResponseStatus(report.id)
    },
    scheduledFor: function (date) {
      return date ? this.formatToMerchantTimeZone(date, false) : 'sent immediately'
    },
    formattedDate: function(date) {
      return this.formatToMerchantTimeZone(date, false)
    },
    sendAtStatus: function (campaign) {
      let sendAtFormatted = this.formatToMerchantTimeZone(campaign.details.time_sent)
      if (!campaign.details.send_at && !campaign.details.time_sent && !campaign.details.cancelled_at) { sendAtFormatted = 'sending'}
      if (campaign.details.send_at && !campaign.details.time_sent && !campaign.details.cancelled_at) { sendAtFormatted = 'scheduled for later'}
      if (campaign.details.cancelled_at) { sendAtFormatted = '--'}
      return sendAtFormatted
    },
    creditsUsed: function(campaign) {
      let showZeroOrDefault = campaign.details.cancelled_at ? '--' : 0
      return campaign.total_credits ? campaign.total_credits : showZeroOrDefault
    },
    async fetchCampaigns() {
      const campaigns = []
      for (const id of this.campaignIds) {
        const campaign = await campaignAPI.fetchStats(id, this.trackingDuration);
        const details = await campaignAPI.fetchDetails(id)
        campaign.details = details

        campaigns.push(campaign)
      }
      this.campaigns = campaigns
    },
  },
  async created() {
    this.$store.dispatch('LOAD_CURRENT_MERCHANT')
    this.$store.dispatch('LOAD_CURRENT_USER')
    this.campaignIds = this.$route.query["campaign_ids[]"].split(",")
    await this.fetchCampaigns()
  },
  watch: {
    async trackingDuration() {
      await this.fetchCampaigns()
    }
  },
  computed: {
    ...mapGetters([
      'userAbilitiesValue', 'classicCampaignsEnabled'
    ]),

    ...mapState([
      'currentMerchant'
    ]),
  },
}
</script>
<style lang="scss" scoped>
  .modal-header-title {
    font-size: 22px !important;
    font-family: AileronLight;
  }

  .compare-container::v-deep {
    .data-title {
      font-size: 16px;
      color: #0D0D0D;
    }
    .title {
      font-size: 22px;
       color: #0D0D0D;
    }
    .compare-item {
      border-right: 1px solid #128ff9;
    }
     .compare-item:last-child {
      border-right: none !important;
     }
    .selected-groups-section .data-title {
      font-size: 22px !important;
      font-family: AileronLight;
      color: #0D0D0D;
    }
    .email-results {
      font-size: 20px;
    }
  }
  .export-modal-btn {
    position: relative;
  }
  @media (min-width: 768px) {
    .export-modal-btn {
      position: absolute;
      right: 0;
      top: 0;
      margin: 0 !important;
    }
  }
  .campaign-compare-section {
    position: relative;
  }
  main::v-deep{
    header.text-xl {
      font-size: 22px;
      font-family: AileronLight;
      color: #0D0D0D;
    }
  }
  .content-details-section::v-deep {
    label {
      font-family: AileronThin;
    }
  }
  .campaign-title-id {
    font-size: 22px;
    color: #0D0D0D;
    font-family: AileronLight;
  }
  .compare-campaign-details-table td {
    font-size: 16px;
    color: #0D0D0D !important;
    font-family: AileronLight;
  }
  .content-details-section::v-deep {
    .data-title {
      font-size: 22px;
      font-family: AileronLight;
      color: #0D0D0D;
    }
  }
  .campaign-details-section::v-deep {
    table {
      td {
        font-size: 16px;
        font-family: AileronLight;
        color: #0D0D0D;
      }
    }
  }
</style>
